import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgExfoliatingMaskGlyph from './svgs/ExfoliatingMaskGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var exfoliatingMaskGlyph = (props => useIcon(SvgExfoliatingMaskGlyph, SvgExfoliatingMaskGlyph, props));

export { exfoliatingMaskGlyph as default };
